module.exports = __webpack_public_path__ + "static/media/mark-as-unread.4c406fa7.svg";